import React, { useEffect, useState, useCallback, useContext } from 'react';

import { useLocation } from 'react-router-dom';

import icBack from '../../../icons/ic-arrow-back.svg';
import Title from '../../../components/Title';
import AuthContext from '../../../contexts/AuthContext';
import DeleteModal from '../ContentsList/DeleteModal';
import {
  getContentsList,
  deletePublishedContents,
  getPublishedContentsWithOptions
} from '../../../modules/NetworkFunction';
import MyCompleteContents from '../../../components/MyCompleteContents';
import Pagination from '../../../components/Pagination';
import usePaymentStatus from '../../../hooks/usePaymentStatus';
import SetContentsModal from '../ContentsPosting/SetContentsModal';
import inform from '../../../icons/ic-information-tip.svg';

import ShopModeContext from '../../../contexts/ShopModeContext';
import LoadingAnimation from '../../../components/LoadingAnimation';

function PostedContentsManagement({ history, version }) {
  const location = useLocation();
  const { auth } = useContext(AuthContext);
  const token = auth;

  const { shopMode } = useContext(ShopModeContext);

  const [currentPage, setCurrentPage] = useState(1);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [contentsList, setContentsList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [publishedContents, setPublishedContents] = useState([]);

  const [isPublishedContentsLoaded, setIsPublishedContentsLoaded] =
    useState(false);
  const [isContentsLoaded, setIsContentsLoaded] = useState(false);
  const [deleteNo, setDeleteNo] = useState();
  const itemPerPage = 4;
  const [totalItemsNum, setTotalItemsNum] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [shopVersion, setShopVersion] = useState(
    location.state?.shopVersion ? location.state.shopVersion : 'pc'
  );
  const { isPaid } = usePaymentStatus(token);

  const [codeCopyHash, setCodeCopyHash] = useState(false);
  const [codeCopyShopver, setCodeCopyShopver] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const [IsLoadingIndicatorLoaded, setIsLoadingIndicatorLoaded] = useState(true);

  const openDeleteModal = useCallback((publishedContentNo) => {
    setDeleteNo(publishedContentNo);
    setDeleteModalOpen(true);
  });
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleManageContents = (content, productCount, publishContentNo) => {
    console.log('handleManageContents')
    console.log('content: ', content)
    console.log('productCount: ', productCount)
    console.log('publishContentNo: ', publishContentNo)

    // const publishedContent = publishedContents.filter(
    //   (content) => content.contentsNo === contentsNo
    // );
    //const isMobile = publishedContent.mobileYn;
    history.push({
      pathname: '/mypage/post-content',
      state: {
        contentsNo: content.contentsNo,
        isMobile: content.mobileYn,
        isModify: true,
        title: content.title,
        productCount,
        thumbnail: content.thumbnail,
        style: content.style,
        publishedContentNo: content.publishedContentNo,
        shopURL: content.shopURL,
        shopVersion,
        detailPath: content.detailPath
      },
    });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [shopMode, shopVersion]);
  // shopMode, shopVersion, currentPage이 바뀔 때마다 publishedContents를 초기화
  useEffect(() => {
    setPublishedContents([]);
    setFilteredList([]);
    setIsContentsLoaded(false);
    setIsPublishedContentsLoaded(false);
    setIsLoadingIndicatorLoaded(true);
    setTimeout(() => {
      setIsLoadingIndicatorLoaded(false);
    }, 1750);
  }, [shopMode, shopVersion, currentPage]);

  // ContentsList 로딩
  useEffect(() => {
    if (!isContentsLoaded) {
      getContentsList(
        null,
        (data) => {
          setContentsList(
            data.filter(
              (content) =>
                (shopMode === 'cafe24' && content.shop === 'cafe24') ||
                (shopMode === 'makeshop' && content.shop === 'makeshop')
            )
          );
          setIsContentsLoaded(true);
        },
        setIsContentsLoaded,
        (e) => {
          if (e) console.log(e);
        },
        token
      );
    }
  }, [isContentsLoaded, token, shopMode]);

  // shopMode, shopVersion, isPublished 여부와 페이징까지 적용된 publishedContents 불러오기
  useEffect(() => {
    if (!isPublishedContentsLoaded) {
      getPublishedContentsWithOptions(
        {
          userNo: window.sessionStorage.getItem('userNo'),
          shop: shopMode,
          shopVersion: shopVersion === 'pc' ? 0 : 1,
          flag: true,
          currentPage,
          itemPerPage
        },
        (v) => {
          console.log(v)
          setFilteredList(v.contentsList);
          setTotalItemsNum(v.totalCount);
          setIsPublishedContentsLoaded(true);
        },
        () => { },
        (e) => {
          if (e) console.log(e);
        },
        token
      );
    }
  }, [isPublishedContentsLoaded, token, shopMode, shopVersion, currentPage]);

  useEffect(() => {
    console.log('Published Contents:', publishedContents);
    console.log('Filtered List:', filteredList);
  }, [publishedContents, filteredList]);

  const contents = filteredList.map((info, idx) => {
    if (isContentsLoaded && isPublishedContentsLoaded) {
      const correspondingContent = contentsList.find(
        (content) => content.contentsNo === info.contentsNo
      );
      //console.log(info.publishedContentNo, info.isPublished)
      if (!correspondingContent) {
        console.error('No corresponding content found');
        return null;
      }
      return (
        <MyCompleteContents
          key={info.contentsNo}
          title={info.title}
          completeYn={info.completeYn}
          productCount={correspondingContent.itemCount}
          thumbnail={info.thumbnail}
          openDeleteModal={() => {
            openDeleteModal(info.publishedContentNo);
          }}
          handleModifyContents={() => {
            handleModifyContents(info.contentsNo, info.videoURL, info.title, info.publishedContentNo);
          }}
          handleSetContents={() => {
            handleSetContents(info.contentsNo);
          }}
          handleModifyDesign={() => {
            handleModifyDesign(info);
          }}
          handleCodeCopy={() => {
            handleCodeCopy(info);
            openModal();
          }}
          handleManageContents={() => {
            handleManageContents(
              info,
              correspondingContent.itemCount,
              info.publishedContentNo
            );
          }}
          isPublished={filteredList.some(
            (contents) =>
              contents.publishedContentNo === info.publishedContentNo &&
              contents.isPublished
          )}
          style={info.style}
          mobileYn={info.mobileYn}
          itemCount={correspondingContent.itemCount}
        />
      );
    }

  });

  const handleCodeCopy = (content) => {
    setCodeCopyHash(content.hash);
    setCodeCopyShopver(content.mobileYn ? 'mobile' : 'pc');
  };

  const handleModifyContents = (contentsNo, videoURL, title, publishedContentNo) => {
    history.push({
      pathname: '/mypage/contents-making/contents-modal/image-regist',
      state: {
        videoURL,
        contentsNo,
        title,
        isModify: true,
        publishedContentNo,
      },
    });
  };

  const handleModifyDesign = (content) => {
    const publishedContent = content;
    const publishedContentNo = publishedContent.publishedContentNo;
    const isMobile = publishedContent.mobileYn;

    history.push({
      pathname: '/mypage/contents-management',
      state: {
        publishedContentNo,
        isMobile,
        publishedContents: publishedContent, //콘텐츠 No이 아닌 published Content No 으로 바꿔야함. 파일별로 ContentsManagement->Content-design-management따라가면서 바꿀 것.
        isModify: true,
      },
    });
  };

  const handleDeleteContents = (publishedContentNo) => {
    deletePublishedContents(
      {
        publishedContentNo,
        //mobileYn: item.mobileYn,
      },
      () => {
        getPublishedContentsWithOptions(
          {
            userNo: window.sessionStorage.getItem('userNo'),
            shop: shopMode,
            shopVersion: shopVersion === 'pc' ? 0 : 1,
            flag: true,
            currentPage,
            itemPerPage
          },
          (v) => {
            console.log(v)
            setFilteredList(v.contentsList);
            setTotalItemsNum(v.totalCount);
            setIsPublishedContentsLoaded(true);
            setCurrentPage(1);
          },
          () => { },
          (e) => {
            if (e) console.log(e);
          },
          token
        );
      },
      (error) => {
        console.log(error);
      },
      token
    );

    closeDeleteModal();
  };

  const handleSetContents = (contentsNo) => {
    // 쇼핑몰에 배치된 모바일 콘텐츠 개수
    const publishedMobileContentsCount = publishedContents.filter(
      (c) => c.mobileYn === 1 && c.isPublished
    ).length;

    // 쇼핑몰에 배치된 PC 콘텐츠 개수
    const publishedPCContentsCount = publishedContents.filter(
      (c) => c.mobileYn === 0 && c.isPublished
    );

    const canPublish =
      isPaid ||
      publishedMobileContentsCount === 0 ||
      publishedPCContentsCount === 0;

    if (!canPublish) {
      alert(
        '무료 요금제는 PC와 모바일 각각 1개의 콘텐츠를 노출할 수 있습니다.'
      );
      return;
    }

    // published_content에 있지만 isPublished가 false인(배치 전) 콘텐츠 -> published_content 정보 넘겨주기
    history.push({
      pathname: '/mypage/contents-management',
      state: {
        publishedMobileContentsCount,
        publishedPCContentsCount,
        contentsNo,
        isModify: false,
        isMobile: isPaid
          ? false
          : publishedMobileContentsCount === 0 && publishedPCContentsCount >= 1,
        publishedContents: publishedContents.filter(
          (content) => content.contentsNo === contentsNo
        ),
      },
    });
  };

  const Push = () => {
    history.push('/mypage/contents-making/contents-modal/content-regist');
  };

  const Publish = () => {
    if (contentsList.length === 0) {
      alert('등록된 콘텐츠가 없습니다. 콘텐츠를 등록해주세요.');
    } else {
      history.push({
        pathname: '/mypage/content-posting-setting',
        state: {
          isModify: false,
        },
      });
    }
  };

  const Empty = ({ status }) => (
    <div
      style={{
        display: 'flex',
        aligncontents: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: 788,
        alignItems: 'center',
      }}
    >
      <img
        src="/icons/ic-face_gray.png"
        style={{ width: 146, height: 146, marginBottom: 20 }}
      />
      <p style={{ marginBottom: 35, color: '#848484', fontSize: 16 }}>
        {status}된 콘텐츠가 없어요.
      </p>
      <button
        style={{
          backgroundColor: '#FF7A00',
          color: '#fff',
          fontWeight: 600,
          fontSize: 20,
          cursor: 'pointer',
          borderRadius: 50,
          padding: '10px 30px',
          borderColor: 'transparent',
        }}
        onClick={
          contentsList.length === 0 && publishedContents === 0 ? Push : Publish
        }
      >
        콘텐츠 {status}하러 가기 &gt;{' '}
      </button>
      {contentsList.length === 0 && (
        <div
          style={{
            margin: '0 auto',
            marginTop: 170,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <a
            href="https://youtu.be/Ixbhvgy1a0Q?si=3Fi5iyKE1jnI6jzW"
            target="_blank"
            rel="noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={inform}
              style={{
                width: '28px',
                height: '28px',
                verticalAlign: 'sub',
              }}
            />
            <span
              style={{
                color: '#FF7A00',
                fontSize: '14px',
                fontWeight: '400px',
                lineHeight: 'normal',
                marginLeft: '6px',
                verticalAlign: 'text-top',
              }}
            >
              콘텐츠 제작팁이 궁금하신가요 ?
            </span>
          </a>
        </div>
      )}
    </div>
  );

  const handleGoBack = () => {
    history.goBack(); // 뒤로가기
  };

  return (
    <div style={{ paddingBottom: 40, position: 'relatives' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',

        }}
      >
        <div
          onClick={handleGoBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingTop: '33px',
            cursor: 'pointer',
          }}
        >
          <img
            alt="뒤로 가기"
            src={icBack}
            style={{ position: 'absolute', left: 40 }}
          ></img>
        </div>
        <Title title="게시 콘텐츠 관리" />
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'center',
          marginTop: 10,
          marginBottom: 20,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <input
            type="radio"
            name="version"
            id="pc"
            value="pc"
            checked={shopVersion === 'pc'}
            onChange={() => {
              setShopVersion('pc');
            }}
          />
          <label htmlFor="pc">PC</label>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <input
            type="radio"
            name="version"
            id="mobile"
            value="mobile"
            checked={shopVersion === 'mobile'}
            onChange={() => {
              //handleChangeVersion('mobile');
              setShopVersion('mobile');
            }}
          />
          <label htmlFor="mobile">모바일</label>
        </div>
      </div>

      {IsLoadingIndicatorLoaded && (
        <LoadingAnimation />
      )}
      {!IsLoadingIndicatorLoaded && (
        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              textAlign: 'center',
              width: '100%',
              justifyContent: 'space-around',
              marginTop: 55,
            }}
          >
            <p
              style={{
                width: 254,
              }}
            >
              콘텐츠
            </p>
            <p
              style={{
                width: 110,
              }}
            >
              코드삽입
            </p>
            <p
              style={{
                width: 200,
              }}
            >
              형태
            </p>
            <p
              style={{
                width: 230,
              }}
            >
              작업
            </p>
          </div>
          <div
            style={{
              marginBottom: 15,
              marginTop: 15,
              border: '0.5px solid #E7E7E7',
            }}
          ></div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              aligncontents: 'center',
              width: '100%',
              height: 480,
            }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                marginTop: 30,
                flexWrap: 'wrap',
                gap: 20,
              }}
            >
              {filteredList.length === 0 ? (
                <Empty status={contentsList.length === 0 ? '등록' : '게시'} />
              ) : (
                contents
              )}
            </div>
          </div>

          <div
            style={{
              position: 'absolute',
              bottom: 70,
              left: '50%',
              transform: 'translateX(-50%)',
            }}
          >
            <Pagination
              itemsPerPage={itemPerPage}
              totalItems={totalItemsNum}
              paginate={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
          {filteredList.length !== 0 && (
            <a
              href="/mypage/content-posting-setting"
              style={{
                position: 'absolute',
                bottom: 70,
                right: 45,
                fontSize: 18,
                color: '#fff',
                marginRight: 10,
                borderRadius: 30,
                padding: '0px 12px',
                height: 36,
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#FFB600',
              }}
            >
              게시할 콘텐츠 추가하기
            </a>
          )}
        </div>
      )}

      <DeleteModal
        open={isDeleteModalOpen}
        close={() => {
          closeDeleteModal();
          window.location.reload();
        }}
        deleteContents={handleDeleteContents}
        contentsNo={deleteNo}
      ></DeleteModal>

      <SetContentsModal
        open={modalOpen}
        close={closeModal}
        version={codeCopyShopver}
        hash={codeCopyHash}
      ></SetContentsModal>
    </div>
  );
}

export default PostedContentsManagement;
